import React from 'react';
import { ToastContainer } from 'react-toastify';

const WrappedToastContainer = ({ ...rest }) => (
    <ToastContainer {...rest} autoClose={5000} />
);

export default WrappedToastContainer;
